<template>
  <v-autocomplete
    v-bind="$attrs" 
    v-on="$listeners" 
    style="min-width:200px"
    clear-icon="clear"
    :clearable="clearable"
    v-model="internalValue"
    :items="items"
    :label="label"
    :return-object="true"
    multiple
    @input="change"
    :filter="filterFunc"
  >
    <v-list-item slot="prepend-item" ripple @click="toggle">
      <v-list-item-action>
        <v-icon
          >{{ icon }}</v-icon
        >
      </v-list-item-action>
      <v-list-item-content>
        <v-list-item-title>{{
          $t("components.trans-multi-select2.select_all")
        }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <v-divider slot="prepend-item" class="mt-2" />
    <template v-slot:selection="data">{{
      displayFunc
        ? displayFunc(data.item, data.item) + ", "
        : data.item + ", "
    }}</template>
    <template v-slot:item="data">
      <v-list-item v-bind="data.attrs" v-on="data.on">
        <v-list-item-action>
          <v-checkbox v-model="data.attrs.inputValue"></v-checkbox>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{
            displayFunc
              ? displayFunc(data.item, data.item)
              : data.item
          }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>
  </v-autocomplete>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "multi-select-all",
  props: [
    "value",
    "items",
    "rules",
    "label",
    "disabled",
    "clearable",
    "field",
    "itemValue",
    "displayFunc",
    "canSelectAll",
  ],
  mounted() {
    if (this.value !== null && this.value !== undefined) {
      this.internalValue = this.value;
    } else {
      this.internalValue = [];
    }
  },
  data() {
    return {
      internalValue: [],
      selectAll: false,
    };
  },
  computed: {
    allItems() {
      return (
        this.internalValue && this.internalValue.length === this.items.length
      );
    },
    someItems() {
      return (
        this.internalValue && this.internalValue.length > 0 && !this.allItems
      );
    },
    icon() {
      if (this.allItems) return "mdi-close-box";
      if (this.someItems) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
  },
  watch: {
    value: {
      handler(v) {
        //console.log(v);
        if (v !== null && v !== undefined) {
          this.internalValue = v;
        } else {
          this.internalValue = [];
        }
      },
    },
  },
  methods: {
    filterFunc(item, search) {
      console.log(item);
      return this.displayFunc?  this.displayFunc(item, item).toLowerCase().indexOf(search.toLowerCase()) > -1: item.toLowerCase().indexOf(search.toLowerCase()) > -1;
    },
    change($event) {
      let items = $event.filter((o) => o !== null && o !== undefined);
      //console.log(JSON.stringify($event), JSON.stringify(items));
      this.internalValue = items;
      this.$emit("change", items);
      this.$emit("input", items);
    },
    toggle() {
      this.$nextTick(() => {
        if (this.allItems) {
          this.change([]);
        } else {
          this.change(this.items.slice());
        }
      });
    },
  },
};
</script>
